<template>
    <div class="input-wrap">
        <div class="icon-container">
            <span class="icon">🔍</span>
        </div>
        <input
            type="text"
            v-model="text"
            placeholder="Webstars"
        >
    </div>
</template>

<script>
export default {
    name: "SearchBox",
    data() {
        return {
            text: '',
        };
    },
    watch: {
        text(){
            this.$emit("input", this.text);
        }
    },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';

.input-wrap {
    display: flex;
    flex-direction: row;
    width: 100%;
    position: relative;
    
    .icon-container {
        background: var(--pallete_clear_text_color);
        position: absolute;
        margin: 2px;
        height: 90%;
        aspect-ratio: 1;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        .icon{}
    }

    input {
        width: 100%;
        border: none;
        flex: 1;
        padding: 10px 50px;
        border-radius: 25px;
        text-align: center;

        &:focus{
            outline: none;
        }
    }
}
</style>